import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enUS from "@/i18n/en-US.json";
import { BRAND_NAME } from "@/lib/brand";

export const SUPPORTED_LOCALES = ["en-US"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "en-US";

// URL path → locale. Single source of truth. Always returns DEFAULT_LOCALE.
export function localeFromPath(_pathname: string): Locale {
  return "en-US";
}

export function pathForLocale(pathname: string, _locale: Locale): string {
  return pathname.replace(/^\/zh(?=\/|$)/, "") || "/";
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      "en-US": { translation: enUS },
    },
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES,
    // `{{brand}}` resolves everywhere in the locale files, so a product
    // rename stays a one-line change in lib/brand.ts.
    interpolation: { escapeValue: false, defaultVariables: { brand: BRAND_NAME } },
    lng: DEFAULT_LOCALE,
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
